import useMutationApi from 'src/api/useMutationApi';
import ApiError from 'src/api/ApiError';
import { UserDocument } from 'src/types/UserDocuments';

export interface GetDocumentResponse {
  document: UserDocument;
  signedUrl: string;
}

export const useGetDocument = () => {
  return useMutationApi<{ documentId: string }, GetDocumentResponse>({
    endpoint: `core/documents/signed-url`,
    method: 'POST',
    showSuccessToast: false,
    successMessage: '',
    showErrorToast: false, // Suppress error toast since we're retrying
    options: {
      retry: (failureCount, error) => {
        // Don't retry more than 2 times
        if (failureCount >= 2) return false;
        // Don't retry on client errors (4xx) - those won't succeed on retry
        if (
          error instanceof ApiError &&
          error.status >= 400 &&
          error.status < 500
        )
          return false;
        // Retry on network errors and server errors (5xx)
        return true;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 3000),
    },
  });
};
